interface AttributionBadgeProps {
  type: 'tor' | 'cloud' | 'scanner' | 'vpn';
  label: string;
  tooltip?: string;
}

const BADGE_STYLES = {
  tor: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  cloud: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  scanner: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  vpn: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
};

export function AttributionBadge({ type, label, tooltip }: AttributionBadgeProps) {
  return (
    <span
      className={`px-2 py-0.5 border rounded text-xs font-medium ${BADGE_STYLES[type]}`}
      title={tooltip}
    >
      {label}
    </span>
  );
}
